/**
 * Runtime module - Execute pre-built walkerOS flows
 */

export {
  loadFlow,
  swapFlow,
  type RuntimeConfig,
  type FlowHandle,
} from './runner';
export {
  resolveBundle,
  type ResolvedBundle,
  type BundleSource,
} from './resolve-bundle';
export {
  fetchConfig,
  type FetchConfigOptions,
  type ConfigFetchResult,
} from './config-fetcher';
export { writeCache, readCache, readCacheConfig } from './cache';
export {
  createHeartbeat,
  getInstanceId,
  type HeartbeatConfig,
  type HeartbeatHandle,
} from './heartbeat';
export { createPoller, type PollerConfig, type PollerHandle } from './poller';
export { createHealthServer, type HealthServer } from './health-server';
export { fetchSecrets, SecretsHttpError } from './secrets-fetcher';
export {
  LogRing,
  ErrorRing,
  type RingEntry,
  type DedupedError,
  type RecentError,
  type RecentLogEntry,
} from './log-ring';
export { redactLine, redactErrors, redactLogs } from './redact';
